(function () {
    angular
        .module("tmx-app")
        .controller("loanApplicationAddCtrl", ["$scope", "$state", "$mdDialog", "$filter", "LoanApplicationService", "tmxResource", "tmxUtility", "$stateParams", "resolvedData", "$window", "APP_CONSTANTS", "lookupService", "cacheStore", "ToastService", "uuid", "TMX_FINANCE_CONSTANTS",
            function LoanApplicationAddCtrl($scope, $state, $mdDialog, $filter, LoanApplicationService, tmxResource, tmxUtility, $stateParams, resolvedData, $window, APP_CONSTANTS, lookupService, cacheStore, ToastService, uuid, TMX_FINANCE_CONSTANTS) {

                //#region Dev Notes
                /*
                                Guidelines for Devs here: 
                                1- Starting point is the self calling function Initialize page
                */
                //#endregion


                //#region  Variables initialization
                var vm = this;
                var exists;
                exists = tmxUtility.exists;
                vm.tenant = APP_CONSTANTS.tenant;
                vm.idvalue = "";
                vm.fetchEcib = fetchEcib;
                vm.calculateLSA = calculateLSA;
                vm.fetchExistingCustomer = fetchExistingCustomer;
                vm.fetchCustomerByCNIC = fetchCustomerByCNIC;
                vm.vm = {};
                vm.vm.TmxCustomerAddressMapping = [];
                vm.vm.TmxCustomerDetails = [];
                vm.cancel = cancel;
                vm.createApplication = createApplication;
                vm.save = save;
                vm.verifiedCustomer = {};
                var culture = localStorage.getItem('culture');
                vm.direction = culture == "ar" ? "rtl" : "ltr";
                var WorkflowStates = [];
                vm.getETB = getETB;
                vm.disableETBButton = disableETBButton;
                vm.verified = false;
                vm.defaultNewCustomerSelected = true;
                var LookUpName = "";
                vm.formatMonthYear = tmxUtility.formatMonthYear;
                vm.getUniqueHistoryType = getUniqueHistoryType;
                vm.getValueByProductDataObj = getValueByProductDataObj;
                vm.selectFirst = false;
                vm.IDValueMaxLength = null;
                vm.showAttachedApplication = false;
                vm.ecibFieldsDataChange = ecibFieldsDataChange;
                vm.IdentifierTypeChange = IdentifierTypeChange;
                var TenantsList = TMX_FINANCE_CONSTANTS.TENANTS;
                var productId = $stateParams.Id;
                var companyBranchId = $stateParams.branchId;
                vm.attachedApplication = false;
                vm.existingApplication = false;
                vm.searchGridColumns = LoanApplicationService.searchGridColumns;
                vm.applicationSelectChange = applicationSelectChange;
                vm.getVisibleValueByLookupId = getVisibleValueByLookupId;
                vm.loanProducts = resolvedData.loanProducts.data;
                vm.getProductNameById = getProductNameById;
                vm.NewCustomerRow = true;
                vm.loanApplicationObj = {};
                var WorkflowStateName = "";
                var roleName;
                vm.newCustomer = true;
                vm.customersList = [];
                vm.IDsList = [];

                var lkupType = TMX_FINANCE_CONSTANTS.LOOKUP_TYPES;
                var LoggedInUserConfigurations = cacheStore.get("Configurations");
                var products = tmxResource("Product");

                vm.ClientTypeLookups = lookupService.getLocalLookupsByType(lkupType.CLIENT_TYPE);
                vm.ClientTypeLkp;
                vm.ClientTypeChange = ClientTypeChange;

                var IsETBSuccessful = false;
                var IsECIBSuccessful = false;
                var bypassECIB = false;
                var isETBSelectionMandatory = false;
                vm.formatDate=tmxUtility.formatDateForCompany;
                //#endregion

                //#region  Local functions
                function readConfigurations() {
                    if (LoggedInUserConfigurations) {
                        vm.allowNadraVerisis = tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'ALLOW_NADRA_VERISIS_ON_STATIC_PAGE', true, productId);
                        vm.tenant = tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'INTEGRATION_TENANT').toLowerCase();
                        // SilkBank
                        vm.showRejectionReasonGrid = tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'SHOW_REJECTION_REASON_GRID').toLowerCase();
                        vm.FIELD_LENGTH = tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'FIELD_LENGTH');
                        vm.showAttachedApplication = tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'SHOW_SECONDARY_GRID', true, productId)
                        vm.SHOW_SEARCH_GRID = tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'SHOW_SEARCH_GRID', true, productId);
                        vm.showECIB = tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'ALLOW_ECIB_ON_STATIC_PAGE', true);
                        vm.smartAdvanceProduct = tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'SMART_ADVANCE_PRODUCT', true, productId);
                        //added  by adeel 07-01-2020
                        if (tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'IS_ETB_SELECTION_MANDATORY', true)) {
                            isETBSelectionMandatory = true;
                        }
                        vm.isNadraVerysisMandatory = tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'IS_NADRA_VERYSIS_MANDATORY', true, productId) == true;

                        vm.disableSaveBtn = true;
                    }
                }

                function setTenantBasedConfigurations() {
                    if (TenantsList.UBANK == vm.tenant) {
                        vm.isUbankTenant = true;
                    }
                    if (TenantsList.VITAS_LEB == vm.tenant || TenantsList.VITAS_IRQ == vm.tenant) {
                        LookUpName = lkupType.IdentificationDocumentTypes;
                    }
                    else if (TenantsList.SILK == vm.tenant || TenantsList.UBANK == vm.tenant || TenantsList.SAMBA == vm.tenant) {
                        LookUpName = lkupType.ID_TYPE;
                    }
                    else {
                        LookUpName = lkupType.ID_TYPE;
                    }

                    if (TenantsList.SILK == vm.tenant) {
                        vm.selectFirst = true;
                    }
                    if (TenantsList.VITAS == vm.tenant) {
                        LookUpName = lkupType.IdentificationDocumentTypesStaticPage;
                        vm.isJordanTenant = true;
                    }
                    if (TenantsList.VITAS_EG == vm.tenant) {
                        LookUpName = lkupType.IdentificationDocumentTypesStaticPage;
                    }

                }
                function getVisibleValueByLookupId(LookupId) {
                    var APPLICATION_STATUS = lookupService.getLocalLookupsByType(lkupType.APPLICATION_STATUS);
                    var LookupObj = APPLICATION_STATUS.filter(function (item) {
                        return item.LookupId == LookupId
                    })[0];
                    if (LookupObj) {
                        return LookupObj.VisibleValue;
                    }
                    else {
                        return 'N/A';
                    }

                }

                function getProductNameById(ProductId) {
                    var productObj = vm.loanProducts.filter(function (item) {
                        return item.ProductId == ProductId
                    })[0];
                    if (productObj) {
                        return productObj.ProductName;
                    }
                    else {
                        return 'N/A';
                    }
                }

                function IdentifierTypeChange(IdentifierTypeValue) {
                    vm.ecibFieldsDataChange();

                    if (IdentifierTypeValue) {
                        vm.IDValueMaxLength = findIdentifierTypeMaxLength(IdentifierTypeValue);
                    }
                    else {
                        vm.IDValueMaxLength = null;
                    }
                }

                function ClientTypeChange(clientType) {
                    vm.isCompanyClient = lookupService.getHiddenValueById(clientType) == "1";
                    vm.EntityTypeID = vm.isCompanyClient ? 1 : 2;
                }

                function findIdentifierTypeMaxLength(typeId) {
                    if (exists(typeId)) {
                        var lookup = lookupService.getLookupById(typeId);
                        return exists(lookup) ? lookup.LookupName : null;
                    }
                    return null;
                }

                function ecibFieldsDataChange() {
                    vm.ecibData = {};
                    vm.ecibData.LoanDetails = [];
                    vm.resourceForEcibGrid = [];
                    vm.ecibLoanDetails = [];
                    vm.ecibHistoryDateArray = [];
                }

                function onlyUnique(value, index, self) {
                    return self.indexOf(value) === index;
                }

                function getUniqueHistoryType(LoanDetails) {
                    if (exists(LoanDetails) && exists(LoanDetails.TmxeCIBDetailHistoryMap)) {
                        var ecibHistoryType = LoanDetails.TmxeCIBDetailHistoryMap.TmxeCIBDetailHistory.map(a => a.HistoryType);
                        if (ecibHistoryType)
                            return ecibHistoryType.filter(onlyUnique);
                    }
                    return "";
                }

                function getValueByProductDataObj(product, date, obj) {
                    if (obj.TmxeCIBDetailHistoryMap != null)
                        obj = obj.TmxeCIBDetailHistoryMap.TmxeCIBDetailHistory.filter(a => a.HistoryType == product && a.OverdueDate == date)[0];
                    if (obj) {
                        return obj.Amount;
                    }
                    else {
                        return 0;
                    }
                }

                function DataInitialization() {
                    lookupService.getLookupByType(LookUpName).then(function (IdentifierTypeLkp) {
                        if (IdentifierTypeLkp) {
                            vm.IdentifierLkp = IdentifierTypeLkp;

                            if (vm.selectFirst) {
                                vm.IdentifierTypeChange(vm.IdentifierLkp[0].LookupId);
                            }
                        }
                    });
                    vm.addIdentificationDocumentNumber();
                    vm.showEcibDetail = false;
                }
                function disableETBButton(){
                    if(vm.etbClicked || vm.ecibClicked)
                        return true;
                    else
                        return false;
                }
                function getETB() {
                    if (vm.idvalue) {
                        $scope.cnic = vm.idvalue;
                        vm.etbClicked = true;
                        tmxResource('Integration').getByAction('GetETB/' + vm.idvalue, true, 'get').then(function (response) {
                            //Added by Adeel 07-01-2020
                            IsETBSuccessful = true;
                            if ((!vm.showECIB||IsECIBSuccessful || bypassECIB) && (!isETBSelectionMandatory || response.data.length == 0)) {
                                vm.disableSaveBtn = false;
                            }

                            if (response.data.length > 0) {
                                vm.customerMasterList = angular.copy(response.data);
                                vm.customerMasterList.sort(function (obj1, obj2) {

                                    if (obj1.TmxCustomerDetail.length > 0 && obj2.TmxCustomerDetail.length > 0) {
                                        var date1 = new Date(obj1.TmxCustomerDetail[0].RelationWithBanks);
                                        var date2 = new Date(obj2.TmxCustomerDetail[0].RelationWithBanks);
                                        if (date1 > date2) return -1;
                                        if (date1 < date2) return 1;

                                    }
                                    return 0;
                                })


                            }
                            else {
                                //vm.NewCustomerRow = true;
                                vm.customerMasterList = [];
                                //vm.defaultNewCustomerSelected = true;
                            }
                        })

                    }
                    else {
                        ToastService.showCustomToast("default", "Please Enter Id document number");
                    }
                }

                function getRoleName() {
                    for (var key in JSON.parse(localStorage.getItem('LoggedInUserPrivileges')).roles) {
                        if (JSON.parse(localStorage.getItem('LoggedInUserPrivileges')).roles.hasOwnProperty(key)) {
                            roleName = JSON.parse(localStorage.getItem('LoggedInUserPrivileges')).roles[key].name;
                            break;
                        }
                    }
                }


                function postJson() {
                    if (TenantsList.VITAS == vm.tenant || TenantsList.VITAS_EG == vm.tenant || TenantsList.VITAS_IRQ == vm.tenant) {
                        if (vm.newCustomer) {
                            vm.loanApplicationObj = {
                                "LoanProductId": $stateParams.Id,
                                "CompanyBranchId": companyBranchId,
                                "WorkflowState": WorkflowStateName,
                                "TmxCustomerMaster": [
                                    {

                                        "ExistingCustomer": 9,
                                        "CustomerName": vm.FirstName,
                                        "NationalIdentifierValue": vm.IDsList[0].IdentificationDocumentNumber,
                                        "NationalIdTypeLkp": vm.IDsList[0].IdentificationDocumentTypeID,
                                        "ClientType": vm.ClientTypeLkp,
                                        "TmxCustomerDetail": [
                                            {
                                                "TmxPerson": {
                                                    "PersonFirstName": vm.CompanyName,
                                                    "PersonCurrentAddress": "",
                                                    "TmxPersonToAddressMapping": [
                                                        {
                                                            // "TmxAddress":
                                                            // {
                                                            //   "AddressLine1":""
                                                            // }                                                
                                                        }
                                                    ]
                                                    ,
                                                    "PersonDateOfBirth": vm.BirthDate
                                                }
                                            }
                                        ],

                                    }
                                ],

                            };
                        }
                        else {
                            vm.loanApplicationObj.TmxCustomerMaster[0]["NationalIdentifierValue"] = vm.IDsList[0].IdentificationDocumentNumber;
                            vm.loanApplicationObj.TmxCustomerMaster[0]["NationalIdTypeLkp"] = vm.IDsList[0].IdentificationDocumentTypeID;
                        }
                    }
                    else if (TenantsList.VITAS_LEB == vm.tenant) {
                        if (vm.newCustomer && !vm.attachedApplication && !vm.existingApplication) {
                            vm.loanApplicationObj = {
                                "LoanProductId": $stateParams.Id,
                                "CompanyBranchId": companyBranchId,
                                "WorkflowState": WorkflowStateName,
                                "TmxCustomerMaster": [
                                    {
                                        "ExistingCustomer": 9,
                                        "CustomerName": `${vm.FirstName}${exists(vm.MiddleName) ? " " + vm.MiddleName : ""}${exists(vm.LastName) ? " " + vm.LastName : ""}`,
                                        "EnglishName": vm.EnglishName,
                                        "MotherName": vm.MotherName,
                                        "MotherFamilyName": vm.MotherFamilyName,
                                        "CdrFirstName": vm.CdrFirstName,
                                        "CdrFatherName": vm.CdrFatherName,
                                        "CdrFamilyName": vm.CdrFamilyName,
                                        "CdrMotherName": vm.CdrMotherName,
                                        "CdrMotherFamilyName": vm.CdrMotherFamilyName,
                                        "NationalIdentifierValue": vm.IDsList[0].IdentificationDocumentNumber,
                                        "NationalIdTypeLkp": vm.IDsList[0].IdentificationDocumentTypeID,
                                        "ETBFetchFlag": vm.ETBFetchFlag ?? 0,
                                        "TmxCustomerDetail": [
                                            {
                                                "TmxPerson": {
                                                    "PersonFirstName": vm.FirstName,
                                                    "PersonMiddleName": vm.MiddleName,
                                                    "PersonLastName": vm.LastName,
                                                    "PersonCurrentAddress": "",
                                                    "PersonDateOfBirth": vm.BirthDate
                                                }
                                            }
                                        ],

                                    }
                                ],
                            };
                        }
                        if(!vm.attachedApplication){
                            vm.loanApplicationObj.TmxCustomerMaster[0].negcustomer = vm.negcustomer;
                            vm.loanApplicationObj.TmxCustomerMaster[0].ReasonsList = vm.reasonsList;
                        }
                        modifyIdNumbers(vm.loanApplicationObj);
                    }
                    else if (TenantsList.UBANK == vm.tenant) {
                        var verifiedPersonData = LoanApplicationService.verifiedCustomer ? LoanApplicationService.verifiedCustomer.personData : null;
                        if (vm.newCustomer && !vm.attachedApplication && !vm.existingApplication) {
                            vm.loanApplicationObj = {
                                "LoanProductId": $stateParams.Id,
                                "CompanyBranchId": companyBranchId,
                                "WorkflowState": WorkflowStateName,
                                "TmxCustomerMaster": [
                                    {
                                        "ExistingCustomer": 9,
                                        "CustomerName": verifiedPersonData ? verifiedPersonData.name : vm.CustomerName,
                                        "NationalIdentifierValue": vm.idvalue,
                                        "NationalIdTypeLkp": vm.IdentifierLkpValue,
                                        "CNICExpiryUdf": LoanApplicationService.BVSVerified ? verifiedPersonData.expiryDate : null,
                                        "NationalIdIssueDateUdf": LoanApplicationService.BVSVerified ? verifiedPersonData.issueDate : null,
                                        "Verysis": LoanApplicationService.BVSVerified ? 1 : 0,
                                        "BVSError": LoanApplicationService.BVSError,
                                        "TmxCustomerDetail": [
                                            {
                                                "TmxPerson": {
                                                    "PersonCurrentAddress": vm.AddressLine1,
                                                    "AddressLine2": vm.AddressLine2,
                                                    "AddressLine3": vm.AddressLine3,
                                                    "TmxPersonToAddressMapping": [
                                                        {
                                                            "TmxPersonAddressContact": [
                                                                {
                                                                    "ContactEmailAddress": vm.ContactEmailAddress,
                                                                    "ContactNumber": "0",
                                                                    "ActiveFlag": 1
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "PersonDateOfBirth": verifiedPersonData ? verifiedPersonData.dateOfBirth : vm.PersonDateOfBirth,
                                                    "PersonPermanentAddress": LoanApplicationService.BVSVerified ? verifiedPersonData.presentAddress : "",
                                                    "MotherFirstNameUdf": LoanApplicationService.BVSVerified ? verifiedPersonData.motherName : "",
                                                    "PlaceOfBirthUdf": LoanApplicationService.BVSVerified ? verifiedPersonData.birthPlace : "",
                                                }
                                            }
                                        ],
                                        "TmxECIBDetail": vm.ecibData.LoanDetails
                                    }
                                ],
                                "TmxLoanApplicationChecklist": [{

                                    "Attachment": vm.base64Pdf,
                                    "LoanApplicationChecklistId": 0,
                                    "AttachmentURL": vm.ecibPdfUrl,
                                    "LoanProductChecklistId": vm.ECIBPdfChecklistId,
                                    "LoanApplicationId": 0,
                                    "CreatedBy": "lo1@vitas.com",
                                    "CreatedDate": "2018-10-25T05:33:12.68",
                                    "LastUpdatedBy": "lo1@vitas.com ",
                                    "LastUpdatedDate": "2018-10-25T10:45:26.123",
                                    "ImageData": null,
                                    "MimeType": "application/pdf",
                                    "DocumentVersion": null
                                }]
                            };
                        }
                        else if (!vm.existingApplication) {
                            vm.loanApplicationObj.TmxCustomerMaster[0].Verysis= LoanApplicationService.BVSVerified ? 1 : 0;
                            vm.loanApplicationObj.TmxCustomerMaster[0].BVSError = LoanApplicationService.BVSError;
                            vm.loanApplicationObj.TmxCustomerMaster[0].TmxECIBDetail = vm.ecibData.LoanDetails;
                        }
                        vm.loanApplicationObj.TmxCustomerMaster[0].ScreeningStatus = 'Cleared';
                    }
                    else { // Case for Silk, Samba, Ubank and Default
                        if(vm.isSilkTenant == true){
                            vm.CustomerName = [vm.FirstName,vm.MiddleName,vm.LastName].join(' ');
                        }
                        {
                            if (vm.newCustomer && !vm.attachedApplication && !vm.existingApplication) {
                                vm.loanApplicationObj = {
                                    "LoanProductId": $stateParams.Id,
                                    "CompanyBranchId": companyBranchId,
                                    "WorkflowState": WorkflowStateName,
                                    "TmxCustomerMaster": [
                                        {
                                            "ExistingCustomer": 9,
                                            "CustomerName": vm.CustomerName,
                                            "NationalIdentifierValue": vm.idvalue,
                                            "NationalIdTypeLkp": vm.IdentifierLkpValue,
                                            "TmxCustomerDetail": [
                                                {
                                                    "TmxPerson": {
                                                        "PersonFirstName": vm.FirstName,
                                                        "PersonMiddleName": vm.MiddleName,
                                                        "PersonLastName": vm.LastName,
                                                        "PersonCurrentAddress": vm.AddressLine1,
                                                        "AddressLine2": vm.AddressLine2,
                                                        "AddressLine3": vm.AddressLine3,
                                                        "TmxPersonToAddressMapping": [
                                                            {
                                                                "TmxPersonAddressContact": [
                                                                    {
                                                                        "ContactEmailAddress": vm.ContactEmailAddress,
                                                                        "ContactNumber": "0",
                                                                        "ActiveFlag": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "PersonDateOfBirth": vm.PersonDateOfBirth
                                                    }
                                                }
                                            ],
                                            "TmxECIBDetail": vm.ecibData.LoanDetails
                                        }
                                    ],
                                    "TmxLoanApplicationChecklist": [{

                                        "Attachment": vm.base64Pdf,
                                        "LoanApplicationChecklistId": 0,
                                        "AttachmentURL": vm.ecibPdfUrl,
                                        "LoanProductChecklistId": vm.ECIBPdfChecklistId,
                                        "LoanApplicationId": 0,
                                        "CreatedBy": "lo1@vitas.com",
                                        "CreatedDate": "2018-10-25T05:33:12.68",
                                        "LastUpdatedBy": "lo1@vitas.com ",
                                        "LastUpdatedDate": "2018-10-25T10:45:26.123",
                                        "ImageData": null,
                                        "MimeType": "application/pdf",
                                        "DocumentVersion": null
                                    }]
                                };
                            }
                            else if (!vm.existingApplication) {
                                vm.loanApplicationObj.TmxCustomerMaster[0].TmxECIBDetail = vm.ecibData.LoanDetails;
                            }
                        }
                    }

                    SetMobileIdInObject(vm.loanApplicationObj);

                    vm.loanApplicationObj.TmxCustomerMaster[0]["IsECIBFetchedUDF"] = IsECIBSuccessful;
                    vm.loanApplicationObj.TmxCustomerMaster[0]["EcibFetchFlag"] = IsECIBSuccessful;
                    vm.loanApplicationObj.TmxCustomerMaster[0]["ContactNumber"] = vm.ContactNumber;
                    LoanApplicationService.createLoanApplication(vm.loanApplicationObj).then(function (response) {
                        if (response.data.LoanApplicationId) {
                            $state.go('private.transaction.loanapplication.edit', { 'Id': response.data.LoanApplicationId });
                        }
                    });

                }

                function modifyIdNumbers(loanObj) {
                    if (loanObj.TmxCustomerMaster[0] && loanObj.TmxCustomerMaster[0].TmxCustomerDetail[0] && loanObj.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson) {
                        var IdNumber = getText(loanObj.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonFirstName) + getText(loanObj.TmxCustomerMaster[0].MotherName) + tmxUtility.formatDateSpecific(loanObj.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonDateOfBirth, "YYYYMMDD");
                        loanObj.TmxCustomerMaster[0].NationalIdentifierValue = IdNumber;
                    }
                }

                function getText(stringObj) {
                    return exists(stringObj) ? stringObj : "";
                }
                function ModifyMobileIdInObject(obj) {
                    if (!exists(obj)) return;
                    if (Object.prototype.toString.call(obj) == '[object Object]') {
                        //if(!exists(obj.MobileID)){ // Modify Mobile ID for new insertion
                        obj.MobileID = uuid.v4();
                        //}
                        Object.keys(obj).forEach(function (key) {
                            if (Object.prototype.toString.call(obj[key]) == '[object Object]') {
                                SetMobileIdInObject(obj[key]);
                            }
                            else if (Object.prototype.toString.call(obj[key]) == '[object Array]') {
                                angular.forEach(obj[key], function (item, index) {
                                    SetMobileIdInObject(item, index);
                                });
                            }
                        });
                    }
                }
                function SetMobileIdInObject(obj) {
                    if (!exists(obj)) return;
                    if (Object.prototype.toString.call(obj) == '[object Object]') {
                        if (!exists(obj.MobileID)) { // Check if mobile id is already not defined in the object
                            obj.MobileID = uuid.v4();
                        }
                        Object.keys(obj).forEach(function (key) {
                            if (Object.prototype.toString.call(obj[key]) == '[object Object]') {
                                SetMobileIdInObject(obj[key]);
                            }
                            else if (Object.prototype.toString.call(obj[key]) == '[object Array]') {
                                angular.forEach(obj[key], function (item, index) {
                                    SetMobileIdInObject(item, index);
                                });
                            }
                        });
                    }
                }

                function EmptyAllMobileIds(obj) {
                    if (!exists(obj)) return;
                    if (Object.prototype.toString.call(obj) == '[object Object]') {
                        obj.MobileID = undefined;
                        Object.keys(obj).forEach(function (key) {
                            if (Object.prototype.toString.call(obj[key]) == '[object Object]') {
                                EmptyAllMobileIds(obj[key]);
                            }
                            else if (Object.prototype.toString.call(obj[key]) == '[object Array]') {
                                angular.forEach(obj[key], function (item, index) {
                                    EmptyAllMobileIds(item, index);
                                });
                            }
                        });
                    }
                }


                function applicationSelectChange(dataitem) {
                    //var loanApplicationId = dataitem.ApplicationID;
                    var existingApplication = {
                        "ApplicationId": dataitem.LoanApplicationId,
                        "CustomerCode": dataitem.CustomerCode ? dataitem.CustomerCode : '',
                        "AccountNumber": dataitem.ClientReferenceNumber
                    }
                    //var customerCode = dataitem.CustomerCode?dataitem.CustomerCode:'';
                    LoanApplicationService.getExistingApplicationDetails(existingApplication).then(function (response) {
                        if (response.data) {
                            vm.newCustomer = false;
                            vm.existingApplication = true;
                            vm.loanApplicationObj = response.data;
                            if (exists(vm.loanApplicationObj)) {
                                vm.loanApplicationObj.LoanProductId = productId;
                                vm.loanApplicationObj.CompanyBranchId = companyBranchId;
                                vm.loanApplicationObj.LoanApplicationId = 0;
                                vm.loanApplicationObj.TmxProduct = null; // need to forcefully make it null so it wont create descrepancies on insert
                                EmptyAllMobileIds(vm.loanApplicationObj); // need to empty mobile Ids so we could set them later.
                                vm.loanApplicationObj.TmxAttachedApplication = null;
                            }

                            vm.oldCustomerDetail = {
                                ClientID: response.data.TmxCustomerMaster[0].CustomerMasterId,
                                CustomerName: response.data.TmxCustomerMaster[0].CustomerName
                            }
                        }
                        vm.selectedApplicationId = dataitem.ApplicationID;
                        vm.disableSaveBtn = false;


                    })
                }

                function loadMainGridOption() {
                    vm.mainGridOptions = {
                        dataSource: {
                            transport: {
                                read: function (o) {
                                    vm.searchClear = false;
                                    vm.o = angular.copy(o);
                                    vm.filters = vm.o.data.filter;

                                    if (searchedmodifyParams) {
                                        LoanApplicationService.searchApplicationByNumber(searchedmodifyParams).then(function (response) {
                                            o.success(response)
                                        });
                                    }
                                    else {
                                        var response = {};
                                        response.AggregateResults = null;
                                        response.Data = [];
                                        response.Errors = null;
                                        response.Total = 0;
                                        o.success(response);
                                    }
                                },
                                dataType: "json"
                            },
                            schema: {
                                data: "data",
                                total: "Total"
                            },
                            serverPaging: false,
                            serverFiltering: false,
                            serverSorting: false,

                            sort: [{ field: "CreatedDate", dir: "desc" }],
                        },
                        pageable: {
                            refresh: false,
                            pageSizes: true,
                            pageSize: 10,
                            buttonCount: 5
                        },
                        sortable: true,
                        scrollable: false,
                        columns: vm.searchGridColumns
                    };
                }
                function SectionVisibility() {
                    if (TenantsList.SILK == vm.tenant || TenantsList.UBANK == vm.tenant || TenantsList.SAMBA == vm.tenant) {
                        if (TenantsList.SILK == vm.tenant) {
                            vm.isSilkTenant = true;
                        }
                        if (!vm.smartAdvanceProduct) {
                            vm.showBasicCustomerDetail = true;
                            vm.showEtbCustomers = true;
                            vm.showNadraVerisis = true;
                        }

                    }
                    else if (TenantsList.VITAS == vm.tenant || vm.tenant == TenantsList.VITAS_EG || vm.tenant == TenantsList.VITAS_IRQ) {
                        vm.isIraqTenant = (vm.tenant == TenantsList.VITAS_IRQ);
                        vm.showJorUniqueClient = true;
                    }
                    else if (TenantsList.VITAS_LEB == vm.tenant) {
                        vm.isLebanonTenant = true;
                    }
                    else {
                        vm.showBasicCustomerDetail = true;
                    }

                    vm.showNadraVerisis = vm.showNadraVerisis && !vm.isUbankTenant;
                }

                function cancel() {
                    $state.go("^");
                }
                function fetchCustomerByCNIC() {
                    if (!vm.idvalue) {
                        ToastService.showCustomToast("default", "Please Enter CNIC");
                    }
                    else {
                        LoanApplicationService.fetchCustomerByCNIC(vm.idvalue).then(function (response) {
                            if (response.data) {
                                vm.customersList[0] = response.data;
                                vm.CustomerName = response.data.CustomerName;

                                if (response.data.TmxCustomerDetail && response.data.TmxCustomerDetail[0] && response.data.TmxCustomerDetail[0].TmxPerson) {
                                    if (response.data.TmxCustomerDetail[0].TmxPerson.TmxPersonToAddressMapping && response.data.TmxCustomerDetail[0].TmxPerson.TmxPersonToAddressMapping[0]) {
                                        if (response.data.TmxCustomerDetail[0].TmxPerson.TmxPersonToAddressMapping[0].TmxPersonAddressContact) {
                                            vm.ContactNumber = response.data.TmxCustomerDetail[0].TmxPerson.TmxPersonToAddressMapping[0].TmxPersonAddressContact[0].ContactNumber;
                                            vm.ContactEmailAddress = response.data.TmxCustomerDetail[0].TmxPerson.TmxPersonToAddressMapping[0].TmxPersonAddressContact[0].ContactEmailAddress;
                                        }
                                        if (response.data.TmxCustomerDetail[0].TmxPerson.TmxPersonToAddressMapping[0].TmxAddress)
                                            vm.CustomerAddress = response.data.TmxCustomerDetail[0].TmxPerson.TmxPersonToAddressMapping[0].TmxAddress.AddressLine1;
                                    }
                                    vm.PersonDateOfBirth = response.data.TmxCustomerDetail[0].TmxPerson.PersonDateOfBirth;
                                }
                            }
                        })
                    }
                }
                function fetchExistingCustomer() {
                    if (!vm.idvalue) {
                        ToastService.showCustomToast("default", "Please Enter NIC");
                    }
                    else {
                        LoanApplicationService.fetchExistingCustomer(vm.idvalue).then(function (response) {
                            if (response.data) {
                                vm.customersList = response.data;
                            }
                        })
                    }
                }

                function getWorkflowStates(productId) {
                    LoanApplicationService.getWorkflowStatesByProductId(productId).then(function (response) {
                        WorkflowStates = response.data;
                        angular.forEach(WorkflowStates, function (item) {
                            if (item.Name.includes(roleName)) {
                                WorkflowStateName = item.Name;
                            }
                        });
                    })
                }
                vm.ecibData = {};

                function fetchEcib() {
                    $scope.cnic = vm.idvalue;
                    if (vm.newCustomer) {
                        if (vm.idvalue && vm.PersonDateOfBirth) {
                            vm.ecibClicked = true;
                            var DOB = tmxUtility.formatDateSpecific(vm.PersonDateOfBirth, "YYYY-MM-DD");
                            var ecib = {
                                CNIC: vm.idvalue, NAME: vm.CustomerName, ADDRESS: vm.AddressLine1,
                                DOB: DOB
                            };
                            LoanApplicationService.fetchEcib(ecib).then(function (response) {
                                vm.ecibData.ReportDate = null;
                                if (response.status.code == "200" && response.data && response.data.ECIBExtract != null) {
                                    //Added by Adeel 07-01-2020
                                    IsECIBSuccessful = true;
                                    if (!isETBSelectionMandatory || (exists(vm.customerMasterList) && vm.customerMasterList.length == 0)) {
                                        vm.disableSaveBtn = false;
                                    }
                                    vm.ecibData = response.data.ECIBExtract;
                                    vm.resourceForEcibGrid = response.data.ECIBExtract.LoanDetails;
                                    if (response.data.ECIBExtract.LoanDetails.length > 0) {

                                        vm.ecibLoanDetails = vm.ecibData.LoanDetails;
                                        vm.ecibHistoryDateArray = vm.ecibData.LoanDetails[0].TmxeCIBDetailHistoryMap.TmxeCIBDetailHistory.map(a => a.OverdueDate);
                                        vm.ecibHistoryDateArray = vm.ecibHistoryDateArray.filter(onlyUnique);

                                        vm.showEcibDetail = true;
                                    }
                                    else {
                                        vm.showEcibDetail = false;
                                        vm.resourceForEcibGrid = [];
                                        vm.ecibLoanDetails = [];
                                        vm.ecibHistoryDateArray = [];
                                    }
                                }
                                else if (response.status.code == "400") {
                                    ToastService.showCustomToast("default", response.status.message);
                                    vm.ecibData.LoanDetails = [];

                                    vm.resourceForEcibGrid = [];
                                    vm.ecibData = {};
                                    vm.ecibLoanDetails = [];
                                    vm.ecibHistoryDateArray = [];
                                }
                                else if (response.status.code == "503" && tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'IS_ECIB_TO_BYPASS', true, productId)) {
                                    bypassECIB = true;
                                    if (IsETBSuccessful && (!isETBSelectionMandatory || vm.newCustomer == false || vm.customerMasterList.length == 0)) {
                                        vm.disableSaveBtn = false;
                                    }
                                }
                                else {
                                    vm.showEcibDetail = false;
                                    vm.resourceForEcibGrid = [];
                                    vm.ecibData = {};
                                    vm.ecibLoanDetails = [];
                                    vm.ecibHistoryDateArray = [];
                                }
                            });
                        }
                        else {
                            ToastService.showCustomToast("default", "Please Enter NIC and DOB");
                        }
                    }
                    else if (!vm.newCustomer) {
                        if (vm.idvalue && vm.loanApplicationObj && (exists(vm.loanApplicationObj, 'TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonDateOfBirth') || vm.PersonDateOfBirth)) {
                            if (exists(vm.loanApplicationObj, 'TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonDateOfBirth')) {
                                DOB = vm.formatDateOfBirth(vm.loanApplicationObj.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonDateOfBirth);
                            }
                            else {
                                DOB = vm.formatDateOfBirth(vm.PersonDateOfBirth);
                            }
                            ecib = {
                                CNIC: vm.idvalue,
                                NAME: vm.loanApplicationObj.TmxCustomerMaster[0].CustomerName,
                                ADDRESS: vm.loanApplicationObj.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonCurrentAddress,
                                DOB: DOB
                            };
                            LoanApplicationService.fetchEcib(ecib).then(function (response) {
                                vm.ecibData.ReportDate = null;
                                if (response.status.code == "200" && response.data && response.data.ECIBExtract != null) {
                                    //Added by Adeel 07-01-2020
                                    IsECIBSuccessful = true;
                                    if (IsETBSuccessful) {
                                        vm.disableSaveBtn = false;
                                    }
                                    vm.ecibData = response.data.ECIBExtract;
                                    vm.resourceForEcibGrid = response.data.ECIBExtract.LoanDetails;
                                    if (response.data.ECIBExtract.LoanDetails.length > 0) {
                                        vm.ecibLoanDetails = vm.ecibData.LoanDetails;
                                        vm.ecibHistoryDateArray = vm.ecibLoanDetails[0].TmxeCIBDetailHistoryMap.TmxeCIBDetailHistory.map(a => a.OverdueDate);
                                        vm.ecibHistoryDateArray = vm.ecibHistoryDateArray.filter(onlyUnique);

                                        vm.showEcibDetail = true;
                                    }
                                    else {
                                        vm.showEcibDetail = false;
                                        vm.resourceForEcibGrid = [];
                                        vm.ecibLoanDetails = [];
                                        vm.ecibHistoryDateArray = [];

                                    }
                                }
                                else if (response.status.code == "400") {
                                    ToastService.showCustomToast("default", response.status.message);
                                    vm.ecibData.LoanDetails = [];

                                    vm.resourceForEcibGrid = [];
                                    vm.ecibData = {};
                                    vm.ecibLoanDetails = [];
                                    vm.ecibHistoryDateArray = [];
                                }
                                else {
                                    vm.ecibData.LoanDetails = [];
                                    vm.showEcibDetail = false;
                                    vm.resourceForEcibGrid = [];
                                    vm.ecibData = {};
                                    vm.ecibLoanDetails = [];
                                    vm.ecibHistoryDateArray = [];
                                }
                            });
                        }
                        else {
                            ToastService.showCustomToast("default", "Please Enter NIC and DOB");
                        }
                    }
                }
                function calculateLSA() {
                    if (!IsECIBSuccessful) {
                        ToastService.showCustomToast("error", "Please fetch ECIB to calculate LSA");
                        return;
                    }
                    else {
                        var LSAModel = {
                            CNIC: vm.idvalue,
                            eCIBData: vm.ecibData,
                            ProductId: productId
                        };
                        LoanApplicationService.calculateLSA(LSAModel).then(function (response) {
                            if (response && response.data)
                                vm.LSA = response.data.AvailableAmountValue;
                            vm.LastMonthSalary = response.data.LastNetSalary;
                        });
                    }
                }
                function PerformValidationForSave() {
                    if (vm.tenant == TenantsList.VITAS_LEB) {
                        if (vm.showAttachedApplication && !vm.attachedApplication) { // if the attached application grid is visible and user have not attached any application
                            return $filter('translate')("NoPipelineAttachedMessage");
                        }
                    }
                    if (vm.tenant == TenantsList.UBANK) {
                        if (vm.isNadraVerysisMandatory && !LoanApplicationService.BVSVerified) { // if nadra verisys is enabled and mandatory to be done
                            return $filter('translate')("BVSorNadraVerificationRequired");
                        }
                    }
                    if (vm.smartAdvanceProduct && !IsECIBSuccessful)
                        return $filter('translate')("ECIBRequired");
                    return null;
                }

                function save(form, event) {
                    var validationMessage = PerformValidationForSave();
                    if (validationMessage != null || !form.$valid) {
                        validationMessage = validationMessage || "" + $filter('translate')("FillRequiredFields");
                        ToastService.showCustomToast("error", validationMessage);
                        return;
                    }
                    if (!vm.newCustomer) {
                        vm.confirmationDialog(form, event, vm.oldCustomerDetail);
                    }
                    else {
                        createApplication(form);
                    }
                }

                function createApplication(form) {
                    if (vm.smartAdvanceProduct) {
                        vm.loanApplicationObj = {
                            "LoanProductId": $stateParams.Id,
                            "CompanyBranchId": companyBranchId,
                            "WorkflowState": WorkflowStateName,
                            "TmxCustomerMaster": [
                                vm.customersList[0]
                            ]
                        };
                        ModifyMobileIdInObject(vm.loanApplicationObj);
                        vm.loanApplicationObj.TmxCustomerMaster[0]["IsECIBFetchedUDF"] = IsECIBSuccessful;
                        vm.loanApplicationObj.TmxCustomerMaster[0]["LSA"] = vm.LSA;
                        vm.loanApplicationObj.TmxCustomerMaster[0]["OTP"] = "";
                        vm.loanApplicationObj.TmxCustomerMaster[0]["LastMonthSalary"] = vm.LastMonthSalary;
                        vm.loanApplicationObj.TmxSmartAdvance = [];
                        vm.TmxSmartAdvances = {};
                        vm.TmxSmartAdvances.CustomerMasterId = vm.loanApplicationObj.TmxCustomerMaster[0].CustomerMasterId;
                        vm.loanApplicationObj.TmxSmartAdvance.push(vm.TmxSmartAdvances);
                        LoanApplicationService.createLoanApplication(vm.loanApplicationObj).then(function (response) {
                            if (response.data.LoanApplicationId) {
                                $state.go('private.transaction.loanapplication.edit', { 'Id': response.data.LoanApplicationId });
                            }
                        });
                    }
                    else {
                        if (vm.newCustomer) {
                            form.$submitted = true;
                        }

                        if ((form.$valid && vm.newCustomer) || !vm.newCustomer || vm.attachedApplication) {
                            postJson();
                        }

                    }
                }
                //#endregion

                //#region VM/Scope Functions
                vm.DownloadPdf = function () {
                    if (vm.resourceForEcibGrid) {
                        var url = ENV.ecibURL + vm.idvalue + '.pdf';
                        $window.open(url, "_blank");
                        vm.ecibPdfUrl = url;
                        products.getChecklistByProductId($stateParams.Id).then(function (response) {
                            response.data.forEach(function (data) {
                                if (data.ChecklistItemName == 'ECIB Document') {
                                    vm.ECIBPdfChecklistId = data.ProductChecklistId;
                                }
                            })
                        })
                        vm.toDataURL(url, function (dataUrl) {
                            vm.base64Pdf = dataUrl;
                        });
                    }
                };

                vm.toDataURL = function (url, callback) {
                    var xhr = new XMLHttpRequest();
                    xhr.onload = function () {
                        var reader = new FileReader();
                        reader.onloadend = function () {
                            callback(reader.result);
                        }
                        reader.readAsDataURL(xhr.response);
                    };
                    xhr.open('GET', url);
                    xhr.responseType = 'blob';
                    xhr.send();
                }

                vm.removeIdentificationDocumentNumber = function (index) {
                    vm.IDsList.splice(index, 1);
                }

                vm.addIdentificationDocumentNumber = function () {
                    vm.IDsList.push(
                        {
                            "ID": "",
                            "IdentificationDocumentTypeID": "",
                            "IdentificationDocumentNumber": "",
                            "DateofIssuance": "",
                            "ExpiryDate": "",
                            "rowState": "Added",
                            "UserId": vm.UserId
                        }
                    )
                }

                vm.checkUniqueClients = function () {
                    vm.disableSaveBtn = true;
                    var defaultValue = (vm.isIraqTenant ? "" : null);
                    var uniqueClientJson = {
                        "NewDataSet": {
                            "Table": {
                                "UserId": vm.UserId,
                                "ClientID": vm.ClientID,
                                "EntityID": vm.EntityID,
                                "EntityTypeID": vm.EntityTypeID,
                                "IsReference": vm.IsReference,
                                "FirstName": vm.FirstName || defaultValue,
                                "FatherName": vm.FatherName || defaultValue,
                                "GrandfatherName": vm.GrandfatherName || defaultValue,
                                "LastName": vm.LastName || defaultValue,
                                "BirthDate": vm.BirthDate || defaultValue,
                                "ID": vm.ID,
                                "CompanyName": vm.CompanyName,
                                "MotherName": vm.MotherName || defaultValue
                            },
                            "IDsList": vm.IDsList
                        }
                    }

                    tmxResource('Integration').getByAction('GetUniqueClients', false, 'post', uniqueClientJson).then(function (response) {
                        if (response.data.WADataRootResult) {
                            vm.uniqueCustomersList = response.data.WADataRootResult.Table;
                            if (exists(vm.uniqueCustomersList) && vm.uniqueCustomersList.length == 0) {
                                //Added by Adeel 07-01-2020
                                if (vm.showECIB) {
                                    if (IsECIBSuccessful || bypassECIB) {
                                        vm.disableSaveBtn = false;
                                    }
                                }
                                else {
                                    vm.disableSaveBtn = false;
                                }

                                vm.NewCustomerRow = true;
                                vm.newCustomer = true;
                            }
                            else {
                                vm.NewCustomerRow = false;
                                vm.newCustomer = false;
                            }
                        }
                    })
                }

                vm.checkUniqueClientsLeb = function () {
                    vm.disableSaveBtn = true;
                    if (exists(vm.dialogForm, '$error.required') && vm.newCustomer) { // only checking required because unique clients might be done in arabic
                        ToastService.showCustomToast("default", $filter('translate')("FillRequiredFields"));
                        return;
                    }
                    var uniqueClientJson = {
                        "NewDataSet": {
                            "Table": {
                                "FirstName": vm.FirstName,
                                "MiddleName": vm.MiddleName,
                                "LastName": vm.LastName,
                                "EnglishName": vm.EnglishName,
                                "CDRFirstName": vm.CdrFirstName,
                                "CDRFatherName": vm.CdrFatherName,
                                "CDRMotherName": vm.CdrMotherName,
                                "CDRFamilyName": vm.CdrFamilyName,
                                "BirthDate": vm.BirthDate
                            },
                            "IDsList": vm.IDsList
                        }
                    }

                    tmxResource('Integration').getByAction('GetUniqueClients', false, 'post', uniqueClientJson).then(function (response) {
                        vm.negCustomer = 0;
                        vm.reasonsList = null;
                        if (response.data.WADataRootResult) {
                            vm.uniqueCustomersList = response.data.WADataRootResult.Table;
                            vm.ETBFetchFlag = 1;
                            if (!isETBSelectionMandatory || vm.uniqueCustomersList.length == 0) {
                                vm.disableSaveBtn = false;
                            }
                            if(tmxUtility.exists(vm.uniqueCustomersList) && vm.uniqueCustomersList.length > 0){
                                let blacklistedRecords= vm.uniqueCustomersList.filter(x=>(tmxUtility.exists(x.Reason) && x.Reason.toLowerCase().includes("blacklist") ))
                                    .map(y=>y.Reason);
                                if(tmxUtility.exists(blacklistedRecords) && blacklistedRecords.length > 0){
                                    vm.negcustomer = 1;
                                    vm.reasonsList = blacklistedRecords.join(',');
                                }  
                            }

                        }
                    })
                }

                vm.TranslateModelValues = function () {
                    var lebTranslationModelMapping = LoanApplicationService.lebTranslationModelMapping;
                    var requestModel = {};
                    Object.keys(lebTranslationModelMapping).forEach(key => {
                        requestModel[lebTranslationModelMapping[key]] = vm[key];
                    });
                    tmxResource('Integration').getByAction('TranslateModelValues', false, 'post', requestModel).then(function (response) {
                        if (exists(response.data)) {
                            Object.keys(lebTranslationModelMapping).forEach(key => {
                                vm[key] = response.data[lebTranslationModelMapping[key]];
                            });
                        }
                    });
                }

                vm.viewETBCustomerDetail = function (index) {

                    $mdDialog.show({
                        controller: ['$mdDialog', '$scope', 'customerMasterData', 'lookupService', 'TMX_FINANCE_CONSTANTS', CustomerDetailDialogController],
                        locals: { customerMasterData: vm.customerMasterList[index] },
                        templateUrl: 'app/private/transaction/loan-application/add/view-customer-detail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose: true,
                        fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                    })
                        .then(function () {

                        }, function () {

                        });
                }

                vm.etbRadioButtonChange = function (index) {

                    if (index != 'null') {
                        //customer screening failed
                        if(vm.customerMasterList[index].ETBResponseCode != "1") {
                            vm.errorDialog(vm.customerMasterList[index].ETBResponseMessage);
                            vm.disableSaveBtn = true;
                            return;
                        }
                        vm.customerMasterList[index].ExistingCustomer = 8;
                        vm.newCustomer = false;
                        vm.loanApplicationObj = {
                            "LoanProductId": $stateParams.Id,
                            "CompanyBranchId": companyBranchId,
                            "WorkflowState": WorkflowStateName,
                            "TmxCustomerMaster": [
                                vm.customerMasterList[index]
                            ]
                        };

                        vm.oldCustomerDetail = {
                            ClientID: index,
                            CustomerName: vm.customerMasterList[index].CustomerName
                        }
                        if (IsECIBSuccessful || bypassECIB)
                            vm.disableSaveBtn = false;
                    }
                    else {
                        vm.vm = {};
                        vm.newCustomer = true;
                    }
                }

                vm.radioButtonChange = function (ClientID) {
                    if (tmxUtility.exists(ClientID)) {
                        vm.newCustomer = false;

                        LoanApplicationService.fetchExistingCustomer(ClientID).then(function (response) {
                            if (Array.isArray(response.data)) {
                                vm.loanApplicationObj = {
                                    "LoanProductId": $stateParams.Id,
                                    "CompanyBranchId": companyBranchId,
                                    "WorkflowState": WorkflowStateName,
                                    "TmxCustomerMaster": [
                                        response.data[0]
                                    ]
                                };
                                vm.loanApplicationObj.TmxCustomerMaster[0].ExistingCustomer = 8;
                                //Added by Adeel 07-01-2020
                                if (vm.showECIB) {
                                    if (IsECIBSuccessful || bypassECIB) {
                                        vm.disableSaveBtn = false;
                                    }
                                }
                                else {
                                    vm.disableSaveBtn = false;
                                }
                            }

                            vm.oldCustomerDetail = vm.uniqueCustomersList.filter(function (item) {
                                return item.ClientID = ClientID;
                            })[0]

                        });
                    }
                    else {
                        vm.vm = {};
                        vm.newCustomer = true;
                    }
                }


                vm.viewCustomerDetail = function (ClientID) {

                    if(!tmxUtility.exists(ClientID)){
                        ToastService.showCustomToast("default", $filter('translate')("SelectValidRecordMessage"));
                        return;
                    }
                    LoanApplicationService.fetchExistingCustomer(ClientID).then(function (response) {
                        if (Array.isArray(response.data)) {
                            $mdDialog.show({
                                controller: ['$mdDialog', '$scope', 'customerMasterData', 'lookupService', CustomerDetailDialogController],
                                locals: { customerMasterData: response.data[0] },
                                templateUrl: 'app/private/transaction/loan-application/add/view-customer-detail.html',
                                parent: angular.element(document.body),
                                clickOutsideToClose: true,
                                fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                            })
                                .then(function () {

                                }, function () {

                                });
                        }
                    })

                }               

                vm.formatDateOfBirth = function (dateTime) {
                    if (dateTime) {
                        //var date= new Date(dateTime + 'Z');
                        var date = new Date(dateTime);
                        var month = date.getUTCMonth() + 1; //months from 1-12
                        var day = date.getUTCDate();
                        var year = date.getUTCFullYear();
                        return day + "/" + month + "/" + year;
                    }
                    else {
                        return 'N/A';
                    }
                }
                vm.viewECIBDetail = function (index, data) {
                    var ecibData = vm.resourceForEcibGrid[index];
                    if (index > -1) {
                        ecibData = vm.resourceForEcibGrid[index];
                    }
                    else if (data && Object.keys(data).length) {
                        ecibData = data;
                    }

                    $mdDialog.show({
                        controller: ['$mdDialog', '$scope', 'TMX_FINANCE_CONSTANTS', 'ecibData', ecibDetailDialogController],
                        locals: { ecibData: ecibData },
                        templateUrl: 'app/private/transaction/loan-application/add/view-ecib-detail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose: true,
                        fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                    })
                        .then(function () {
                        }, function () {
                        });
                }

                vm.searchAvailableApplication = function () {
                    tmxResource("LoanApplication").getByAction("GetUnattachedSecondaryApplications/" + productId, true).then(function (response) {
                        vm.availableApplicationList = response.data;
                        document.getElementById("newapplicationradio").checked = true;
                    });
                }

                vm.selectApplication = function (applicationId) {
                    if (applicationId != null) {
                        tmxResource("LoanApplication").getByAction("GetApplicationForCopy/" + applicationId).then(function (response) {
                            vm.attachedApplication = true;
                            vm.disableSaveBtn = false;
                            vm.loanApplicationObj = response.data;
                            if (exists(vm.loanApplicationObj)) {
                                vm.loanApplicationObj.LoanProductId = productId;
                                vm.loanApplicationObj.CompanyBranchId = companyBranchId,
                                vm.loanApplicationObj.LoanApplicationId = 0;
                                vm.loanApplicationObj.TmxProduct = null; // need to forcefully make it null so it wont create descrepancies on insert
                                EmptyAllMobileIds(vm.loanApplicationObj); // need to empty mobile Ids so we could set them later.
                                vm.loanApplicationObj.TmxAttachedApplication = [{ SecondaryLoanAppId: applicationId }];
                            }
                        });
                    }
                    else {
                        vm.attachedApplication = false;

                    }
                }

                var searchedmodifyParams = "";
                vm.searchApplications = function (searchParameter) {
                    searchedmodifyParams = searchParameter;
                    vm.loanApplicationObj = null;
                    vm.container.applicationGrid.dataSource.read();
                }

                vm.getSignature = function () {
                    $mdDialog.show({
                        controller: ['$scope', '$mdDialog', 'AreaLkp', 'IdentifierLkp', 'IdentifierLkpValue', 'idvalue', function ($scope, $mdDialog, AreaLkp, IdentifierLkp, IdentifierLkpValue, idvalue) {
                            $scope.signatureImage = [];
                            $scope.FP_ISO = null;
                            $scope.FP_IMG = null;
                            $scope.SSCImage = [];
                            $scope.AreaLkp = AreaLkp;
                            $scope.IdentifierLkp = IdentifierLkp;
                            $scope.IdentifierLkpValue = IdentifierLkpValue;
                            $scope.idvalue = idvalue;
                            $scope.showSampleButton = ENV.environment == 'dev' ? true : false;
                            $scope.verifiedCustomer = null;
                            $scope.verified = false;
                            $scope.hardcoded = false;
                            $scope.disablebutton = true;
                            angular.forEach($scope.IdentifierLkp, function (item) {
                                if (item.LookupId == $scope.IdentifierLkpValue && item.VisibleValue == "NIC Number (ID-N)") {
                                    if (angular.isDefined($scope.idvalue) && $scope.idvalue != null && $scope.idvalue != "") {
                                        $scope.cnic = $scope.idvalue;
                                    }
                                }
                            });
                            $scope.disablebutton = function () {
                                if (angular.isDefined($scope.AreaLkpValue) && $scope.AreaLkpValue != null && angular.isDefined($scope.cnic) && $scope.cnic != "") {
                                    return false;
                                }
                                else
                                    return true;
                            }
                            $scope.hide = function () {
                                $mdDialog.hide();
                            };

                            $scope.cancel = function () {
                                $mdDialog.cancel();
                            };

                            $scope.getSampleSignature = function () {

                                $scope.hardcoded = true;
                                $scope.FP_IMG = "data:image/png;base64," + "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";
                                $scope.verifiedCustomer = {};
                                $scope.verifiedCustomer.citizenNumber = "4210146432762";
                                $scope.verifiedCustomer.personData = {};
                                $scope.verifiedCustomer.personData.name = "xyz";
                                $scope.verifiedCustomer.personData.fatherHusbandName = "abc";
                                $scope.verifiedCustomer.personData.presentAddress = "abc";
                                $scope.verifiedCustomer.personData.permanentAddress = "abc";
                                $scope.verifiedCustomer.personData.dateOfBirth = "1991-09-09";
                                $scope.verifiedCustomer.personData.birthPlace = "abc";
                                $scope.verifiedCustomer.personData.expiryDate = "2018-09-09";
                                $scope.verifiedCustomer.personData.photograph = "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";
                                $scope.verified = true;
                            }

                            $scope.getSampleSSC = function (index) {
                                $scope.SSCImage[index] = 'data:image/png;base64,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';
                            }
                            vm.verified = false;
                            $scope.getSignature = function () {

                                // eslint-disable-next-line no-undef
                                tx_deviceInit(supported_device.SECUGEN);
                                // eslint-disable-next-line no-undef
                                tx_deviceGet(supported_device.SECUGEN,
                                    function (response) {
                                        response = JSON.parse(response);
                                        if (response.STATUS == "SUCCESS") {
                                            $scope.FP_ISO = response.FP_ISO;
                                            $scope.FP_IMG = "data:image/png;base64," + response.FP_IMG;
                                            angular.forEach($scope.AreaLkp, function (item) {
                                                if (item.LookupId == $scope.AreaLkpValue) {
                                                    $scope.AreaLkpValue = item.VisibleValue;
                                                }
                                            });
                                            var bioverificationrequest = {
                                                "cnic": $scope.cnic,//"4210113379199",
                                                "area": $scope.AreaLkpValue,//"sindh",
                                                "iso": $scope.FP_ISO,
                                            }
                                            tmxResource('Integration').getByAction('GetBioVerification', false, 'post', bioverificationrequest).then(function (response) {
                                                if (response.data.responseData) {
                                                    $scope.verifiedCustomer = response.data.responseData;
                                                    $scope.verified = true;
                                                }
                                                else if(response.data.status && response.data.status.code == 417) {
                                                    $scope.customErrorDialog("Error", response.data.status.message);
                                                }
                                                else
                                                    $scope.error = "Error: " + "Details not found";
                                            });
                                        }
                                        else {
                                            $scope.error = "Error: " + response.ERROR;
                                            $scope.verifiedCustomer = null;
                                            $scope.verified = false;
                                        }
                                    },
                                    function () {
                                        $scope.error = "Error: Device drivers not found";
                                    }
                                );
                            }

                            $scope.done = function () {
                                if (angular.isDefined($scope.verifiedCustomer) && $scope.verifiedCustomer != null) {
                                    $mdDialog.hide({
                                        verifiedCustomer: $scope.verifiedCustomer,
                                    });
                                }
                                else {
                                    $scope.error = "NADRA Verisys Required"
                                }
                            };
                        }],
                        templateUrl: 'common/signature-dialog.html',
                        parent: angular.element(document.body),
                        locals: {
                            AreaLkp: vm.AreaLkp,
                            IdentifierLkp: vm.IdentifierLkp,
                            IdentifierLkpValue: vm.IdentifierLkpValue,
                            idvalue: vm.idvalue
                        },
                        clickOutsideToClose: false,
                    })
                        .then(function (data) {
                            if (angular.isDefined(data.verifiedCustomer)) {
                                vm.verified = true;
                            }
                            else
                                vm.verified = false;
                        }, function () {
                        });
                }

                vm.confirmationDialog = function (form, ev, oldCustomerDetail) {
                    var confirm = $mdDialog.confirm()
                        .clickOutsideToClose(true)
                        .title('Confirm Customer')
                        .htmlContent('You are going to select <br><br><b>Client Id:</b> ' + oldCustomerDetail.ClientID + '<br><b>Customer Name:</b> ' + oldCustomerDetail.CustomerName)
                        .ariaLabel('Lucky day')
                        .targetEvent(ev)
                        .ok('Yes')
                        .cancel('Cancel');
                    $mdDialog.show(confirm).then(function (response) {
                        if (response) {
                            createApplication(form);
                        }
                    });
                }

                vm.errorDialog = function (alertMessage) {
                    var alert = $mdDialog.alert()
                        .clickOutsideToClose(false)
                        .title('Blocked Customer')
                        .htmlContent('The selected customer is blacklisted. Cannot proceed with application.<br><br><b>' + alertMessage + '</b> ')
                        .ariaLabel('Lucky day')
                        //.targetEvent(ev)
                        .ok('Close')
                    $mdDialog.show(alert)
                    .finally(function() {
                        alert = undefined;
                      });
                }

                $scope.customErrorDialog = function (title,alertMessage) {
                    var alert = $mdDialog.alert()
                        .clickOutsideToClose(false)
                        .title(title)
                        .htmlContent(alertMessage)
                        .ariaLabel('Lucky day')
                        //.targetEvent(ev)
                        .ok('Close')
                    $mdDialog.show(alert)
                    .finally(function() {
                        alert = undefined;
                      });
                }

                vm.onDocumentTypeChange = function (idType, scope, index) {
                    vm.IDsList[index].idValueMaxLength = findIdentifierTypeMaxLength(idType);
                }

                //#endregion

                //#region Child Controllers

                function CustomerDetailDialogController($mdDialog, $scope, customerMasterData, lookupService, TMX_FINANCE_CONSTANTS) {
                    $scope.vm = {};

                    var lkupType = TMX_FINANCE_CONSTANTS.LOOKUP_TYPES;

                    var addressTypeLkp = lookupService.getLocalLookupsByType(lkupType.ADDRESS_TYPE);
                    var PermanentAddressId = 0;
                    var CurrentResidenceAddressId = 0;

                    var PERMANENT_ADDRESS = addressTypeLkp.filter(function (item) {
                        return item.HiddenValue == 'PERMANENT';
                    });

                    var TEMPORARY_ADDRESS = addressTypeLkp.filter(function (item) {
                        return item.HiddenValue == 'TEMPORARY';
                    });

                    if (PERMANENT_ADDRESS.length)
                        PermanentAddressId = PERMANENT_ADDRESS[0].LookupId;
                    if (TEMPORARY_ADDRESS.length)
                        CurrentResidenceAddressId = TEMPORARY_ADDRESS[0].LookupId;

                    if (customerMasterData.TmxCustomerDetail[0].TmxPerson) {
                        $scope.PermanentAddressIndex = customerMasterData.TmxCustomerDetail[0].TmxPerson.TmxPersonToAddressMapping.map(function (item) { return item.AddressTypeLkp; }).indexOf(PermanentAddressId);
                        $scope.CurrentResidenceAddressIndex = customerMasterData.TmxCustomerDetail[0].TmxPerson.TmxPersonToAddressMapping.map(function (item) { return item.AddressTypeLkp; }).indexOf(CurrentResidenceAddressId);
                    }

                    $scope.vm = customerMasterData;
                    $scope.vm.isUbankTenant = vm.isUbankTenant;
                    $scope.vm.formatDate = vm.formatDate;
                    $scope.ok = function () {
                        $mdDialog.hide();
                    };

                    $scope.cancel = function () {
                        $mdDialog.hide();
                    };
                }


                function ecibDetailDialogController($mdDialog, $scope, TMX_FINANCE_CONSTANTS, ecibData) {
                    $scope.vm = {};
                    $scope.vm.ecibData = ecibData;
                    $scope.showOk = true;

                    $scope.ok = function () {
                        $mdDialog.hide();
                    }

                    $scope.cancel = function () {
                        $mdDialog.hide();
                    };
                    $scope.vm.lookup = {};
                    var lkupType = TMX_FINANCE_CONSTANTS.LOOKUP_TYPES;

                    lookupService.getLookupByType(lkupType.YES_NO).then(function (response) {
                        $scope.vm.lookup.yesNOLkp = response;
                    });
                }

                //#endregion

                products.getChecklistByProductId = function (ProductId) {
                    return products.getByAction("GetChecklistByProductId/" + ProductId, true);
                };

                (function InitializePage() {
                    readConfigurations();
                    setTenantBasedConfigurations();
                    DataInitialization();
                    getWorkflowStates($stateParams.Id);
                    getRoleName();
                    loadMainGridOption();
                    SectionVisibility();
                })();
            }]);
})();

